import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
} from "../../../../_metronic/_helpers";
import { sizePerPageList } from "../../../utility";

export const CrprgpTable = ({
  data,
  page,
  sizePerPage,
  onTableChange,
  totalSize,
  loading,
}) => {
  const columns = [
    {
      text: "Mandt",
      dataField: "mandt",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Client Code",
      dataField: "client_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Non Returnable",
      dataField: "non_returnable",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Non Fraction",
      dataField: "non_fraction",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "CRP Before",
      dataField: "crp_before",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "CRP After",
      dataField: "crp_after",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "RGP Before",
      dataField: "rgp_before",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "RGP After",
      dataField: "rgp_after",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "RGP Remark",
      dataField: "rgp_remark",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Status CRP",
      dataField: "status_crp",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
  ];

  const options = {
    page: page,
    sizePerPage: sizePerPage,
    showTotal: true,
    totalSize: totalSize,
    sizePerPageList: sizePerPageList,
  };

  return (
    <BootstrapTable
      remote
      wrapperClasses="table-responsive"
      classes="table table-head-custom table-vertical-center overflow-hidden"
      bootstrap4
      bordered={false}
      keyField="customerId"
      data={data === null ? [] : data}
      columns={columns}
      pagination={paginationFactory(options)}
      onTableChange={onTableChange}
    >
      <PleaseWaitMessage entities={loading ? null : data} />
      <NoRecordsFoundMessage entities={loading ? null : data} />
    </BootstrapTable>
  );
};
